import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";

const Dimension1AutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label = "Dimension 1", load = true, disabled = false, infoText, error, helperText }) => {
    return (
        <AsyncAutoCompleteContained
            label={label}
            url="/autocompleteApi/Dimension1"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={disabled}
        />
    );
};

export default Dimension1AutoComplete;
